import { render, staticRenderFns } from "./DomainListsButton.vue?vue&type=template&id=79ae7f45&"
import script from "./DomainListsButton.vue?vue&type=script&lang=js&"
export * from "./DomainListsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports